import React from "react";
import Carousel from "react-gallery-carousel"; /* https://github.com/yifaneye/react-gallery-carousel/tree/d1e07a345518094f314428946e66033ae08558a4 */
import "react-gallery-carousel/dist/index.css";
import * as Utils from "../utils/Utils.js";

export default class MediaCarousel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      thumbs: [],
      mediaElements: [],
    };

    this.focused = false;

    this.carouselRef = React.createRef();
  }

  componentDidMount() {
    let eventTitle = Utils.getEventTitle();
    let thumbnails = [];
    let carousel = [];

    let lenght = this.props.media.length;

    for (var i = 0; i < lenght; i++) {
      /*THUMBNAILS*/
      if (this.props.media[i].type == "video") {
        let video = this.props.media[i];

        let thumb =
          "https://img.youtube.com/vi/" +
          video.thumbnail_url.split("vi/")[1].substring(0, 11) +
          "/sddefault.jpg";

        thumbnails.push(
          <img
            alt={eventTitle}
            className="r_carouselThumbnail"
            style={{
              height: "100vh",
              width: "100vw",
              objectFit: "cover",
              fontSize: 200,
              fontWeight: "bold",
            }}
            key={i}
            src={thumb}
          ></img>
        );
      } else {
        thumbnails.push(
          <img
            alt={eventTitle}
            id={"carouselItem" + i}
            className="r_carouselThumbnail"
            style={{
              height: "100vh",
              width: "100vw",
              objectFit: "cover",
              fontSize: 200,
              fontWeight: "bold",
            }}
            key={i}
            src={this.props.media[i].src}
          ></img>
        );
      }

      /*CAROUSEL*/
      if (this.props.media[i].type == "video") {
        let video = this.props.media[i];
        let src =
          "//www.youtube.com/embed/" +
          video.thumbnail_url.split("vi/")[1].substring(0, 11);
        +"?autoplay=1";

        carousel.push(
          <iframe
            id={"r_evPgCarVid" + i}
            index={i}
            allowFullScreen
            className="r_mediaCarouselVideo"
            src={src}
            key={i}
          />
        );
      } else {
        carousel.push(
          <img
            alt={eventTitle}
            index={i}
            className="r_mediaCarouselImage"
            key={i}
            src={this.props.media[i].src}
          ></img>
        );
      }
    }

    this.setState({
      thumbs: thumbnails,
      mediaElements: carousel,
    });
    if (thumbnails.length === 1) {
      $(".carouselIcon").hide();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.focused) {
      this.focused = true;

      this.carouselRef.current.goToIndex(this.props.goTo);
    }
  }

  onIndexChange = ({ curIndex }) => {
    try {
      let video = document.getElementById("r_evPgCarVid" + (curIndex - 1));

      if (video != undefined && video != null) {
        let parent = video.parentElement;
        let content = video;
        video.remove();

        parent.appendChild(content);
      }
    } catch (e) {}
  };

  render() {
    /*Class is added for displaying thumbs differently, mainly for mobile view, as to not get them stacked to the left if they are few*/
    let thumbsClass = "";
    if (this.state.thumbs.length == 1) {
      thumbsClass = "r_thumbHide";
    } else if (this.state.thumbs.length <= 9) {
      thumbsClass = "r_centerFlex";
    }

    return (
      <section className="section r_carouselSection">
        <header className="section-header"></header>
        <div className="carousel-container">
          <Carousel
            ref={this.carouselRef}
            onIndexChange={this.onIndexChange}
            className={thumbsClass}
            hasSizeButton={false}
            hasIndexBoard={false}
            canAutoPlay={false}
            style={{ height: "90vh", width: "100%" }}
            thumbnails={this.state.thumbs}
            leftIcon={
              <img
                className={"carouselIcon"}
                src={"/Site/images/icons/EventPage/media-left.svg"}
              />
            }
            rightIcon={
              <img
                className={"carouselIcon"}
                src={"/Site/images/icons/EventPage/media-right.svg"}
              />
            }
          >
            {this.state.mediaElements}
          </Carousel>
        </div>
      </section>
    );
  }
}
